/** Payload fields for retail product/SKU image writes (POST/PUT). */
export interface RetailImageWritePayload {
  image_base64?: string;
  remove_image?: boolean;
}

/**
 * Builds image fields for retail API write requests.
 * - New/changed upload: `image_base64` (supports full data URLs)
 * - User removed existing image on edit: `remove_image: true`
 * - Unchanged S3 URL or no image on create: omit both
 */
export function buildRetailImageWritePayload(options: {
  currentImage: string | null | undefined;
  originalImageUrl?: string | null;
  isEdit: boolean;
}): RetailImageWritePayload {
  const { currentImage, originalImageUrl, isEdit } = options;
  const trimmed = currentImage?.trim();

  if (!trimmed) {
    if (isEdit && originalImageUrl) {
      return { remove_image: true };
    }
    return {};
  }

  if (trimmed.startsWith('data:')) {
    return { image_base64: trimmed };
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    if (isEdit && originalImageUrl && trimmed === originalImageUrl) {
      return {};
    }
    return {};
  }

  return { image_base64: trimmed };
}
